/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const IEOWaveInfo = ({ sectionContent, lang }) => {
  return (
    <>
      <Box
        bg="#F1EBDF"
        mt={{ base: '10px', md: '73px' }}
        maxW={'1026px'}
        mx="auto"
        py={{ base: '34px', md: '44px' }}
        px={{ base: '25px', md: '80px' }}
        textAlign={'center'}
        className="ieo-program-fees-info"
        color={'#000000'}
      >
        <StructuredTextParser
          mt="10px"
          str={render(sectionContent?.[0].body)}
          {...ProgramFeeSt[lang].p}
          maxW="auto"
          color="#3B444B"
        />
        <style jsx global>
          {`
            .ieo-program-fees-info p {
              text-align: center;
            }
            .ieo-program-fees-info {
              p:nth-of-type(1) {
                font-size: 20px;
                color: #000000;
                line-height: 29.5px;
              }

              p:nth-of-type(2) {
                font-size: 22px;
                font-weight: 450;
                color: #6d6358;
                line-height: 28px;
                padding-top: 44px;
              }

              p:nth-of-type(3) {
                padding-top: 24px;
                font-size: 34px;
                font-weight: 500;
                color: #f37021;
                line-height: 34px;
              }
            }
            @media (max-width: 768px) {
              .ieo-program-fees-info {
                p:nth-of-type(1) {
                  font-size: 18px;
                  line-height: 28px;
                }

                p:nth-of-type(2) {
                  font-size: 20px;
                  line-height: 25px;
                  padding-top: 20px;
                }

                p:nth-of-type(3) {
                  padding-top: 24px;
                  font-size: 24px;
                  line-height: 24px;
                }
              }
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default IEOWaveInfo;
